import React from "react";
import { VehicleStatusModal } from "./CheckVehicleStatus";
import { LgLogoModal } from "../common/LgLogoModal";
import VehicleLedgerModal from "../../hooks/vehicle_ledger/VehicleLedgerModal";
import { CheckAdvanceBalanceModal } from "./CheckAdvanceBalance";
import { SyncDailyCollectionsModal } from "./SyncDailyCollectionsModal";
import { CalculateUserWages } from "./CalculateUserWages";

export const Modals = () => {
  return (
    <>
      <VehicleStatusModal />
      <VehicleLedgerModal />
      <LgLogoModal />
      <CheckAdvanceBalanceModal />
      <SyncDailyCollectionsModal />
      <CalculateUserWages />
    </>
  );
};
